import React from 'react';
import { useAppSelector } from '../../../utils/Hooks';
import {apiClient} from "../../../utils/ApiClient";

interface RemovedRoutesTableProps {
    vendorId: number;
    contactId: number;
    routes: {
        startCountry: { id: number; name: string };
        destinationCountry: { id: number; name: string };
        service?: { id: number; name: string | null };
        removed: boolean;
    }[];
    refreshRoutes: () => void;
}

const RemovedRoutesTable: React.FC<RemovedRoutesTableProps> = ({ vendorId, contactId, routes, refreshRoutes }) => {
    const servicesState = useAppSelector((state) => state.services);

    const getServiceName = (serviceId: number, serviceName?: string | null) => {
        return serviceName ?? servicesState.services.find((service) => service.id === serviceId)?.name ?? `#${serviceId}`;
    };

    const toggleRoute = async (startCountryId: number, destinationCountryId: number, serviceId: number) => {
        await apiClient.post(`vendors/${vendorId}/contacts/${contactId}/toggleRoute`, {
            start_country_id: startCountryId,
            destination_country_id: destinationCountryId,
            service_id: serviceId,
        });
        refreshRoutes();
    };

    return (
        <div className="form" style={{ padding: '10px' }}>
            <h2 style={{ padding: '10px' }}>Eemalda soovitustest</h2>
            {routes.length > 0 ? (
                <table style={{ padding: '10px', width: '100%', borderCollapse: 'separate', borderSpacing: '0 10px' }}>
                    <thead>
                    <tr>
                        <th style={{ padding: '10px', textAlign: 'left' }}>Kust</th>
                        <th style={{ padding: '10px', textAlign: 'left' }}>Kuhu</th>
                        <th style={{ padding: '10px', textAlign: 'left' }}>Teenus</th>
                        <th style={{ padding: '10px', textAlign: 'left' }}>Tegevus</th>
                    </tr>
                    </thead>
                    <tbody>
                    {routes.map((route, index) => {
                        const serviceId = route.service?.id ?? 2;

                        return (
                            <tr key={`Remove${route.startCountry.id}-${route.destinationCountry.id}-${serviceId}-${index}`} style={{ backgroundColor: '#f9f9f9', borderRadius: '5px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
                                <td style={{ padding: '10px' }}>{route.startCountry.name}</td>
                                <td style={{ padding: '10px' }}>{route.destinationCountry.name}</td>
                                <td style={{ padding: '10px' }}>{getServiceName(serviceId, route.service?.name)}</td>
                                <td style={{ padding: '10px' }}>
                                    <button
                                        style={{
                                            backgroundColor: route.removed ? '#81C784' : '#E57373',
                                            color: 'white',
                                            padding: '8px 16px',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            fontSize: '12px',
                                            fontWeight: 'bold',
                                            boxShadow: '0 3px 5px rgba(0, 0, 0, 0.1)',
                                            transition: 'background-color 0.3s ease, transform 0.2s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            height: '100%',
                                        }}
                                        onClick={() =>
                                            toggleRoute(route.startCountry.id, route.destinationCountry.id, serviceId)
                                        }
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'scale(1.05)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'scale(1)';
                                        }}
                                    >
                                        {route.removed ? 'Tagasi soovitustesse' : 'Eemalda soovitustest'}
                                    </button>
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            ) : (
                <p>Vedusid ei leitud.</p>
            )}
        </div>
    );
};

export default RemovedRoutesTable;
